module.exports = __webpack_public_path__ + "olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/styles/bootstrap/fonts/glyphicons-halflings-regular.svg
 ** module id = 46
 ** module chunks = 1
 **/